/*******************************************************************************
 * Address Step Actions and Reducer
 */

import {
	ActionMap,
	FormContext_Action_Payload,
} from '@/components/forms/FormContext';
import {
	ReplaceVirtuallyFormState,
	StepMap,
} from '@/app/replace/virtual/components/ReplaceVirtuallyForm/constants';

export const MessageStepActions = {
	UPDATE_MESSAGE: 'UPDATE_MESSAGE',
} as const;

export type MessageStepAction = keyof typeof MessageStepActions;

export interface MessageStepActionPayload
	extends FormContext_Action_Payload<StepMap> {
	[MessageStepActions.UPDATE_MESSAGE]: string;
}

export type MessageStepActionMap =
	ActionMap<MessageStepActionPayload>[keyof ActionMap<MessageStepActionPayload>];

export const isMessageStepActionMap = (
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	action: any,
): action is MessageStepActionMap => action.type in MessageStepActions;

export const messageStepReducer = (
	state: ReplaceVirtuallyFormState,
	action: MessageStepActionMap,
): ReplaceVirtuallyFormState => {
	switch (action.type) {
		case MessageStepActions.UPDATE_MESSAGE:
			return {
				...state,
				message: action.payload,
			};
		default:
			return state;
	}
};

export const isValid = (): boolean => true;
